// extracted by mini-css-extract-plugin
export default {"card":"add-card_card__bawWs","cardLg":"add-card_cardLg__yrxUc","cardMd":"add-card_cardMd__qyLL-","cardSm":"add-card_cardSm__xZw8u","edit":"add-card_edit__ydAxF"};